module.exports = __webpack_public_path__ + "static/media/ZiXun5.9033502f.png";